<template>
  <div class="login-container">
    <LogoIcon />
    <span class="title">Set a password</span>
    <div class="login-content">
      <div class="inputs">
        <div v-show="false" class="floating-label has-icon">
          <input
            :value="email"
            type="email"
            name="email"
            id="email"
            autocomplete="off"
          />
          <label for="email">Email</label>
          <div class="input-icon">
            <MailIcon class="icon mini" />
          </div>
        </div>
        <div class="floating-label has-icon">
          <input
            v-model="password"
            placeholder="Enter password"
            type="password"
            name="password"
            id="password"
            autocomplete="off"
          />
          <label for="password">Password</label>
          <div class="input-icon">
            <MailIcon class="icon mini" />
          </div>
        </div>
        <div class="floating-label has-icon">
          <input
            v-model="passwordConfirm"
            placeholder="Confirm password"
            type="password"
            name="password"
            id="passwordConfirm"
            autocomplete="off"
          />
          <label for="passwordConfirm">Confirm Password</label>
          <div class="input-icon">
            <MailIcon class="icon mini" />
          </div>
        </div>
      </div>
      <button
        @click="next()"
        class="button-default big continue plausible-event-name=Password+Set"
        :disabled="isLoading"
      >
        <span>Continue</span>
      </button>
    </div>
  </div>
</template>
<script>
import LogoIcon from "@/components/LogoTile";
import MailIcon from "@/assets/img/svg/mail.svg";
import { mapState } from "vuex";
import { M_SET_PASSWORD_SIGNUP } from "@/graphql";

export default {
  name: "SignupWizardStepPassword",
  components: {
    LogoIcon,
    MailIcon
  },
  data() {
    return {
      password: null,
      passwordConfirm: null,
      isLoading: false
    };
  },
  created() {
    // this.$store.commit("signup/reset");
  },
  computed: {
    ...mapState("signup", ["email", "email_token"]),
    isPasswordValid() {
      return !!(this.password && this.password === this.passwordConfirm);
    }
  },
  methods: {
    async setPassword() {
      return await this.$apollo.mutate({
        client: "localClient",
        mutation: M_SET_PASSWORD_SIGNUP,
        variables: {
          email: this.email,
          password: this.password
        }
      });
    },
    async next() {
      if(!this.isPasswordValid) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Invalid password, Please enter a valid password."
        });
        return;
        
      }
      this.isLoading = true;
      const result = await this.setPassword();
      this.isLoading = false;
      const { user, token } = result.data.set_password_signup;
      this.$store.commit("signup/setId", user.id);
      localStorage.setItem("token", token);
      this.$emit("nextStep");
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100%;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    .inputs {
      margin-top: 30px;
      width: 100%;
      display: grid;
      grid-gap: 18px;
    }
    button.continue {
      margin-top: 22px;
      width: 100%;
    }
  }
}
@media (max-width: 600px) {
  .login-container {
    padding: 24px;
    .title {
      text-align: center;
    }
    .login-content {
      width: 100%;
      padding: 0;
      .inputs {
        grid-template-columns: repeat(1, 100%);
        width: 100%;
      }
    }
  }
}


</style>
